import React from "react";
import Template from "../components/Template";
import BreadCrumb from "../components/BreadCrumb";

function GroupClasses() {
  return (
    <Template>
      <BreadCrumb pageName="Group Classes" />

      <section className="section-lgx">
        <div className="container">
          <div className="row g-0">
            <div className="col-12 pbmit-footer-right">
              <h2
                style={{
                  textAlign: "center",
                  marginBottom: "30px",
                  color: "#05AAE3",
                }}
              >
                GROUP FITNESS CLASSES
              </h2>
            </div>

            <div className="col-xl-5 col-lg-12">
              <img
                src="https://sunnyhealthfitness.com/cdn/shop/articles/group-fitness-classes-01_0f1ad3bc-1110-42c6-bc9e-5e9cf2d518c5_750x.jpg?v=1741021005"
                className="img-fluid"
                style={{ width: "95%", height: "auto", margin: "0px auto" }}
                alt="Group Fitness Class"
              />
            </div>

            <div
              className="col-xl-7 col-lg-12"
              style={{ display: "flex", alignItems: "center" }}
            >
              <div>
                <div className="pbmit-heading-subheading animation-style1 mb-4">
                  <span
                    style={{
                      fontWeight: "bold",
                      fontSize: 25,
                      textTransform: "uppercase",
                    }}
                  >
                    TRAIN TOGETHER. GROW TOGETHER.
                  </span>
                </div>

                <p>
                  Our group fitness sessions are designed to keep you motivated,
                  energized, and consistent. Train alongside like minded
                  individuals while being guided by expert instructors.
                </p>

                <p>
                  Whether you’re aiming to burn fat, build strength, or stay
                  active, group workouts help you stay accountable and energized
                  every step of the way.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <hr />

      <section className="section-lgx">
        <div className="container">
          <div className="row g-0">
            <div
              className="col-xl-7 col-lg-12"
              style={{ display: "flex", alignItems: "center" }}
            >
              <div>
                <div className="pbmit-heading-subheading animation-style1 mb-4">
                  <span
                    style={{
                      fontWeight: "bold",
                      fontSize: 25,
                      textTransform: "uppercase",
                    }}
                  >
                    CLASS FEATURES
                  </span>
                </div>

                <ul
                  className="list-group list-group-borderless"
                  style={{ marginBottom: 0 }}
                >
                  <li className="list-group-item">
                    High energy group workouts led by certified trainers
                  </li>
                  <li className="list-group-item">
                    Mix of strength, cardio, dance & functional training
                  </li>
                  <li className="list-group-item">
                    Suitable for beginners to advanced levels
                  </li>
                  <li className="list-group-item">
                    Motivating group environment that keeps you consistent
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-xl-5 col-lg-12">
              <img
                src="https://thesweatbox.ca/wp-content/uploads/2024/01/The-Social-Benefits-of-Joining-a-Group-Fitness-Class.jpg"
                className="img-fluid"
                style={{ width: "95%", height: "auto", margin: "0px auto" }}
                alt="Group Workout Session"
              />
            </div>
          </div>
          <div className="text-center mt-5">
            {/* <a href="/contact" className="pbmit-btn pbmit-btn-white">
              Join a Group Class Today
            </a> */}
             <a href="/clarity-call" className="pbmit-btn pbmit-btn-white">
              Join a Group Class Today
            </a>
          </div>
        </div>
      </section>
    </Template>
  );
}

export default GroupClasses;
